import { render, staticRenderFns } from "./TipoEnderecoManage.vue?vue&type=template&id=6231b2c8&scoped=true"
import script from "./TipoEnderecoManage.vue?vue&type=script&lang=js"
export * from "./TipoEnderecoManage.vue?vue&type=script&lang=js"
import style0 from "./TipoEnderecoManage.vue?vue&type=style&index=0&id=6231b2c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6231b2c8",
  null
  
)

export default component.exports